import type { TieOutParty } from '@polatkan/api/services';

export type { CariTieOutReport, StockTieOutReport, TieOutParty, UnmirroredEntry } from '@polatkan/api/services';

export type TieOutApp = 'TRAVEL' | 'TRADING';

/** Balances within this many TRY count as tied out (server uses the same tolerance). */
export const TIE_OUT_TOLERANCE = 0.01;

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export interface DateRangeDraft {
  from: string;
  to: string;
}

export function isoDay(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function utcDate(iso: string): Date {
  return new Date(`${iso}T00:00:00Z`);
}

export function isValidRange(draft: DateRangeDraft): boolean {
  return DATE_RE.test(draft.from) && DATE_RE.test(draft.to) && draft.from <= draft.to;
}

export function defaultRange(today: Date): DateRangeDraft {
  return { from: `${today.getUTCFullYear()}-01-01`, to: isoDay(today) };
}

export function isMismatched(party: Pick<TieOutParty, 'difference'>): boolean {
  return Math.abs(party.difference) > TIE_OUT_TOLERANCE;
}

export function partyHref(app: TieOutApp, party: Pick<TieOutParty, 'kind' | 'id'>): string {
  if (app === 'TRAVEL') return party.kind === 'customer' ? `/travel/cari/accounts/customer/${party.id}` : `/travel/cari/accounts/partner/${party.id}`;
  return party.kind === 'customer' ? `/trading/customers/${party.id}` : `/trading/cari/suppliers/${party.id}`;
}

export function entryHref(app: TieOutApp, entryId: string): string {
  return app === 'TRAVEL' ? `/travel/accounting/journal-entries/${entryId}` : `/trading/accounting/journal-entries/${entryId}`;
}
